var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSoundOnFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.007 8H1V16H5.007L11 21V3L5.007 8Z",
    fill: "#93B5F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M1 15.75V16H5.007L11 21V20.75L5.007 15.75H1Z",
    fill: "#D4E1F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M5.007 8H1V8.25H5.007L11 3.25V3L5.007 8Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.03,
    d: "M1 12V16H5.007L11 21V12H1Z",
    fill: "#93B5F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8271 9.17295L12.4141 10.5859C12.6004 10.7713 12.7483 10.9916 12.8493 11.2342C12.9502 11.4769 13.0021 11.7371 13.0021 11.9999C13.0021 12.2628 12.9502 12.523 12.8493 12.7657C12.7483 13.0083 12.6004 13.2286 12.4141 13.4139L13.8271 14.8269C14.5511 14.1029 15.0001 13.1029 15.0001 11.9999C15.0001 10.8969 14.5511 9.89695 13.8271 9.17295ZM16.6541 6.34595L15.2411 7.75895C16.3271 8.84595 17.0001 10.3459 17.0001 11.9999C17.0001 13.6539 16.3271 15.1539 15.2401 16.2399L16.6541 17.6539C18.1031 16.2059 19.0001 14.2059 19.0001 11.9999C19.0001 9.79395 18.1031 7.79395 16.6541 6.34595Z",
    fill: "#93B5F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8271 9.17295L12.4141 10.5859C12.6004 10.7713 12.7483 10.9916 12.8493 11.2342C12.9502 11.4769 13.0021 11.7371 13.0021 11.9999C13.0021 12.2628 12.9502 12.523 12.8493 12.7657C12.7483 13.0083 12.6004 13.2286 12.4141 13.4139L13.8271 14.8269C14.5511 14.1029 15.0001 13.1029 15.0001 11.9999C15.0001 10.8969 14.5511 9.89695 13.8271 9.17295ZM16.6541 6.34595L15.2411 7.75895C16.3271 8.84595 17.0001 10.3459 17.0001 11.9999C17.0001 13.6539 16.3271 15.1539 15.2401 16.2399L16.6541 17.6539C18.1031 16.2059 19.0001 14.2059 19.0001 11.9999C19.0001 9.79395 18.1031 7.79395 16.6541 6.34595Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4814 3.51904L18.0684 4.93204C19.8784 6.74204 21.0004 9.24204 21.0004 12C21.0004 14.758 19.8794 17.257 18.0684 19.068L19.4814 20.481C21.6544 18.308 23.0004 15.308 23.0004 12C23.0004 8.69204 21.6544 5.69204 19.4814 3.51904Z",
    fill: "#93B5F1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4814 3.51904L18.0684 4.93204C19.8784 6.74204 21.0004 9.24204 21.0004 12C21.0004 14.758 19.8794 17.257 18.0684 19.068L19.4814 20.481C21.6544 18.308 23.0004 15.308 23.0004 12C23.0004 8.69204 21.6544 5.69204 19.4814 3.51904Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSoundOnFlat);
export default __webpack_public_path__ + "static/media/IconSoundOnFlat.103eaeb7dd3aefd32ef8b6065659d8dc.svg";
export { ForwardRef as ReactComponent };